import { render, staticRenderFns } from "./RetailerDashboard.vue?vue&type=template&id=1c6f66f4&"
import script from "./RetailerDashboard.vue?vue&type=script&lang=js&"
export * from "./RetailerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RetailerDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports